import React, { useEffect, useState, FormEvent } from "react";
import { useParams } from "react-router-dom";

import { IInscriptionPayment } from "../../../pages/admin/StudentsPage/StudentDetails/types";
import { formatDate, formatPaymentMethod } from "./types";

const Inscription = () => {
  const { id } = useParams<{ id: string }>();
  const token = localStorage.getItem("token");

  const [showInscriptionForm, setShowInscriptionForm] = useState(false);
  const [inscriptionPayment, setInscriptionPayment] = useState<IInscriptionPayment | null>(null);

  const privilege = parseInt(localStorage.getItem("privilege") || "0");
  const canModifyPayments = privilege === 1 || privilege === 2;

  const [message, setMessage] = useState("");
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [inscriptionPaidAt, setInscriptionPaidAt] = useState("");
  const [inscriptionPaymentMethod, setInscriptionPaymentMethod] = useState("");
  const [inscriptionReferenceNumber, setInscriptionReferenceNumber] = useState("");
  const [inscriptionAmount, setInscriptionAmount] = useState(0);

  useEffect(() => {
    fetch(`https://has-backend-c48d669d897f.herokuapp.com/inscription/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setInscriptionPayment(data.inscriptionPayment);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error al obtener pagos:", err);
        setIsLoading(false);
      });
  }, [refreshTrigger]);

  const handleInscriptionPaymentSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!inscriptionPaymentMethod) {
      setMessage("Selecciona un método de pago válido");
      return;
    }

    try {
      const response = await fetch(`https://has-backend-c48d669d897f.herokuapp.com/inscription/manual/${id}`, {
        method: inscriptionPayment?.paid ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          paidAt: new Date(inscriptionPaidAt).toISOString(),
          amount: inscriptionAmount,
          paymentMethod: inscriptionPaymentMethod,
          referenceNumber: inscriptionReferenceNumber,
        }),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Fallo al registrar/modificar pago de inscripción");

      setShowInscriptionForm(false);
      setRefreshTrigger(prev => prev + 1);
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(`https://has-backend-c48d669d897f.herokuapp.com/inscription/manual/${id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Fallo al eliminar pago de inscripción");

      setRefreshTrigger(prev => prev + 1);
    } catch (err: any) {
      setMessage(err.message);
    }
  };

  return (
    <div className="flex flex-col items-start gap-8 w-full mt-8">
      <div className="w-full flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
        <h2 className="font-playfair font-bold text-3xl sm:text-4xl">Pago de inscripción</h2>
        {canModifyPayments && (
          <button
            onClick={() => setShowInscriptionForm(true)}
            className="bg-[#1c1c2e] border border-[#8E8E8E] rounded-lg text-white font-sourceSans w-full sm:w-1/4 shadow-lg py-2"
          >
            Registrar pago inscripción
          </button>
        )}
      </div>

      {showInscriptionForm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-2">
          <div className="bg-[#d9d9d9] w-full sm:w-2/4 max-h-[90%] overflow-y-auto p-6 rounded-lg shadow-lg relative">
            <button className="absolute top-2 right-2 text-gray-800 text-lg" onClick={() => setShowInscriptionForm(false)}>x</button>
            <form onSubmit={handleInscriptionPaymentSubmit} className="w-full flex flex-col gap-3">
              <label>Tipo de pago</label>
              <select value={inscriptionPaymentMethod} onChange={(e) => setInscriptionPaymentMethod(e.target.value)} >
                <option value="">Selecciona un método</option>
                <option value="transferencia">Transferencia</option>
                <option value="deposito">Depósito</option>
                <option value="efectivo">Efectivo</option>
              </select>

              <label>Fecha</label>
              <input type="date" value={inscriptionPaidAt} onChange={(e) => setInscriptionPaidAt(e.target.value)}  />

              <label>Número de referencia</label>
              <input type="text" value={inscriptionReferenceNumber} onChange={(e) => setInscriptionReferenceNumber(e.target.value)}  />

              <label>Monto</label>
              <input type="number" value={inscriptionAmount} onChange={(e) => setInscriptionAmount(Number(e.target.value))}  />

              <button type="submit" className="mt-4 bg-[#1c1c2e] text-white py-2 rounded-md">
                {inscriptionPayment?.paid ? "Actualizar" : "Registrar"} pago de inscripción
              </button>
            </form>
          </div>
        </div>
      )}

      <div className="w-full flex flex-col">
        {isLoading ? (
          <p>Cargando estado de inscripción...</p>
        ) : inscriptionPayment && inscriptionPayment.paid ? (
          <div className="flex flex-col sm:flex-row justify-between border-y border-gray-600 py-2 px-4 sm:px-8">
            <p className="font-sourceSans text-sm sm:text-base">
              El estudiante pagó la inscripción el día {" "}
              <strong>{formatDate(inscriptionPayment.paidAt)}</strong> mediante {" "}
              <strong>{formatPaymentMethod(inscriptionPayment.paymentMethod)}</strong>. Monto: <strong>${inscriptionPayment.amount} MXN</strong>
            </p>
            {canModifyPayments && (
              <div className="flex flex-col sm:flex-row gap-2 mt-2 sm:mt-0">
                <button
                  onClick={() => setShowInscriptionForm(true)}
                  className="bg-[#1c1c2e] text-white text-sm px-4 py-1 rounded-md"
                >
                  Editar
                </button>
                <button
                  onClick={handleDelete}
                  className="bg-red-600 text-white text-sm px-4 py-1 rounded-md"
                >
                  Eliminar
                </button>
              </div>
            )}
          </div>
        ) : (
          <p className="font-sourceSans px-4">El estudiante aún no ha pagado su inscripción.</p>
        )}
      </div>

      {message && <p className="text-red-600 font-sourceSans px-4">{message}</p>}
    </div>
  );
};

export default Inscription;
